/**
 * JU!CE — FAQ criativo (<jp-faq-creative>).
 * Base = <details> nativo (funciona sozinho, cada resposta abre/fecha independente —
 * é o que "sem JS" e "mobile" sempre mostram). Em telas >=1440px, com JS, clicar na
 * pergunta não abre o próprio <details> (visualmente vazio nesse breakpoint, ver CSS);
 * em vez disso atualiza o painel fixo à esquerda com os dados já presentes nos
 * atributos data-* do <details> clicado (sem duplicar texto visível pra leitor de tela).
 */
(function () {
  'use strict';

  if (customElements.get('jp-faq-creative')) return;

  class JpFaqCreativeElement extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-item]'));
      this.activePanel = this.querySelector('[data-active]');
      if (!this.items.length || !this.activePanel) return;

      this.activePill = this.activePanel.querySelector('[data-active-pill]');
      this.activeNum = this.activePanel.querySelector('[data-active-num]');
      this.activeQuestion = this.activePanel.querySelector('[data-active-question]');
      this.activeKicker = this.activePanel.querySelector('[data-active-kicker]');
      this.activeTitle = this.activePanel.querySelector('[data-active-title]');
      this.activeCopy = this.activePanel.querySelector('[data-active-copy]');
      this.activeChips = this.activePanel.querySelector('[data-active-chips]');

      this.mq = window.matchMedia('(min-width: 1440px)');

      this._onClick = this.onItemClick.bind(this);
      this.items.forEach(function (item) {
        item.addEventListener('click', this._onClick);
      }, this);
    }

    disconnectedCallback() {
      var self = this;
      this.items.forEach(function (item) {
        item.removeEventListener('click', self._onClick);
      });
    }

    onItemClick(event) {
      if (!this.mq.matches) return; // mobile: <details> nativo cuida sozinho

      var summary = event.target.closest ? event.target.closest('summary') : null;
      if (!summary) return;

      event.preventDefault();
      var item = event.currentTarget;
      this.setActive(item);
    }

    setActive(item) {
      this.items.forEach(function (i) { i.open = i === item; });
      this.updatePanel(item);
    }

    updatePanel(item) {
      var flavor = item.getAttribute('data-cor');
      if (this.activePill) this.activePill.setAttribute('data-flavor', flavor);
      if (this.activeNum) this.activeNum.textContent = item.getAttribute('data-numero') || '';
      if (this.activeQuestion) this.activeQuestion.textContent = item.getAttribute('data-pergunta') || '';
      if (this.activeKicker) this.activeKicker.textContent = item.getAttribute('data-kicker') || '';
      if (this.activeTitle) this.activeTitle.textContent = item.getAttribute('data-titulo') || '';
      if (this.activeCopy) this.activeCopy.textContent = item.getAttribute('data-copy') || '';

      if (this.activeChips) {
        var raw = item.getAttribute('data-chips') || '';
        var chips = raw.split('|').map(function (c) { return c.trim(); }).filter(Boolean);
        this.activeChips.innerHTML = '';
        chips.forEach(function (chip) {
          var span = document.createElement('span');
          span.className = 'jp-chip jp-faq-creative__chip';
          span.textContent = chip;
          this.activeChips.appendChild(span);
        }, this);
      }
    }
  }

  customElements.define('jp-faq-creative', JpFaqCreativeElement);
})();
